import './src/styles/variables.css';
import './src/styles/reset.css';
import './src/styles/animations.css';
import './src/styles/typography.css';
import './src/styles/grid.css';
import './src/styles/helpers.css';
import './src/styles/global.css';
import './src/styles/fonts-awesome.css';
import './src/styles/header.css';
import './src/styles/footer.css';

import { createSummalytics } from '@summalytics/js';
import { summalyticsConfig } from './src/utils/summalytics';

const analytics = createSummalytics(summalyticsConfig);

export const onRouteUpdate = ({ location }) => {
  analytics.pageview({ path: location.pathname });
};
